import React from 'react';
import { fmtDec } from '../utils';

export function Categories({ data }) {
  const sorted = [...(data.categories || [])].sort((a, b) => b.total - a.total);
  const posTotal = sorted.filter(c => c.total > 0).reduce((s, c) => s + c.total, 0);
  return (
    <div className="table-card">
      <div className="table-header"><span className="table-header-title">All categories by revenue</span></div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>#</th><th>Category</th><th>Revenue</th><th>Share</th><th>Status</th></tr></thead>
          <tbody>
            {sorted.map((c, i) => {
              const share = c.total > 0 ? (c.total / posTotal * 100).toFixed(1) + '%' : '—';
              return (
                <tr key={c.name}>
                  <td className="td-num">{i + 1}</td>
                  <td>{c.name}</td>
                  <td className="td-money" style={{ color: c.total < 0 ? 'var(--red)' : 'inherit' }}>{fmtDec(c.total)}</td>
                  <td className="td-num">{share}</td>
                  <td>
                    {c.total > 50000 ? <span className="badge badge-green">Top seller</span>
                      : c.total > 0 ? <span className="badge badge-brand">Active</span>
                      : <span className="badge badge-amber">Discount</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function Items({ data }) {
  const { itemsRev = [], itemsQty = [] } = data;
  const revMap = Object.fromEntries(itemsRev);
  const qtyMap = Object.fromEntries(itemsQty);
  const allItems = [...new Set([...itemsRev.map(r => r[0]), ...itemsQty.map(r => r[0])])];
  const rows = allItems.map(item => {
    const rev = revMap[item] || 0;
    const qty = qtyMap[item] || 0;
    const avg = qty > 0 ? rev / qty : 0;
    return { item, rev, qty, avg };
  }).sort((a, b) => b.rev - a.rev);

  return (
    <div className="table-card">
      <div className="table-header"><span className="table-header-title">All items — revenue &amp; quantity</span></div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>#</th><th>Item number</th><th>Revenue</th><th>Quantity</th><th>Avg/unit</th></tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.item}>
                <td className="td-num">{i + 1}</td>
                <td style={{ fontFamily: 'var(--mono)', fontWeight: 500 }}>{r.item}</td>
                <td className="td-money">{fmtDec(r.rev)}</td>
                <td className="td-num">{r.qty.toLocaleString()}</td>
                <td className="td-num">{r.avg > 0 ? '$' + r.avg.toFixed(2) : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Categories;
